module.exports = __webpack_public_path__ + "img/REP.7a2337bb.svg";